import _ from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { PropTypes } from '~/utils';
import { useGlobalContext, useConfig } from '~/hooks';
import { PickList } from '~/components';

export function BigButtons( { buttons, ...props } ) {
  const { dispatch } = useGlobalContext();
  const config = useConfig();

  const handlePick = useCallback( ( pick ) => {
    if ( pick.overlay ) return dispatch.overlay( pick.overlay );
    if ( pick.onPick ) return pick.onPick( pick );
  }, [ dispatch ] );

  const items = useMemo( () => buttons.filter( button => {
    const setting = button.setting;
    if ( ! setting ) return true;
    return config.get( `settings.${setting}` );
  } ), [ buttons, config ] );

  return (
    <PickList
      {...props}
      items={items}
      onPick={handlePick}
    />
  );
}
BigButtons.propTypes = {
  buttons : PropTypes.arrayOf( PropTypes.shape( {
    label       : PropTypes.string.isRequired,
    icon        : PropTypes.string,
    disabled    : PropTypes.bool,
    onPick      : PropTypes.func,
    setting     : PropTypes.string,
  } ) ),
};
